import { PlanDetailUserReviews, gray } from "@kunduz/ui-components";
import React, { ReactElement, useState } from "react";
import styles from "./planDetailV2.module.scss";
import { Divider } from "@kunduz/ui";
import { type IContent } from "@kunduz/data-access-cms-api";
import { useTranslation } from "next-i18next";
import axios from "axios";
import { trackEventNext } from "@kunduz/utility-analytics";

export const PlanDetailReviews = (props: Props): ReactElement => {
  const { t } = useTranslation("kunduzcom_common");
  const [nextUrl, setNextUrl] = useState(props.componentData.data.items.next);
  const [loading, setLoading] = useState(false);
  const [reviews, setReviews] = useState(
    props.componentData.data.items.results,
  );

  const handleLoadMoreClicked = async () => {
    if (!nextUrl) return;
    trackEventNext({
      event: "User Review Show More Button Clicked",
    });
    setLoading(true);
    const response = await axios.get(nextUrl);
    setNextUrl(response.data.next);
    setReviews((oldReviews) => [...oldReviews, ...response.data.results]);
    setLoading(false);
  };

  const handleShowMoreClicked = (user: any) => {
    trackEventNext({
      event: "User Review Expanded",
      user,
    });
  };

  return (
    <section
      className={styles["reviewWrapper"]}
      style={props.style}
      id="reviews"
    >
      <PlanDetailUserReviews.Title>
        {props.componentData.data.title}
      </PlanDetailUserReviews.Title>
      <PlanDetailUserReviews.MetaAndPercWrapper>
        <PlanDetailUserReviews.Meta
          rating={props.metaData?.data.rating}
          reviewLabel={props.metaData?.data.review}
        />
        <PlanDetailUserReviews.Percentages
          five={props.componentData.data.fifth_star_percentage}
          four={props.componentData.data.fourth_star_percentage}
          three={props.componentData.data.third_star_percentage}
          two={props.componentData.data.second_star_percentage}
          one={props.componentData.data.first_star_percentage}
        />
      </PlanDetailUserReviews.MetaAndPercWrapper>

      <Divider top={16} bottom={16} color={gray[200]} />

      <PlanDetailUserReviews.ReviewCardWrapper>
        {reviews?.map(
          (x: IContent.PlanDetailV2ReviewData["items"]["results"][0]) => (
            <PlanDetailUserReviews.ReviewCard
              key={`review_card_${x.order}`}
              title={x.user}
              description={x.description}
              imageUrl={x.image}
              rating={x.rating}
              reviewTitle={x.message_title}
              reviewDesc={x.message}
              onShowMoreClicked={() => handleShowMoreClicked(x.user)}
            />
          ),
        )}
      </PlanDetailUserReviews.ReviewCardWrapper>
      {nextUrl && (
        <PlanDetailUserReviews.LoadMoreButton
          onClick={handleLoadMoreClicked}
          disabled={loading}
        >
          {t("user_review_component_cta_button_label")}
        </PlanDetailUserReviews.LoadMoreButton>
      )}
    </section>
  );
};

interface Props {
  metaData?: any;
  componentData: IContent.PlanDetailV2Option<IContent.PlanDetailV2ReviewData>;
  style: any;
}
